/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6a7027d3ca5a74a5b079c29e0d99f59a0641a474";
